// import React from 'react';
import { wrapperBuilder } from './build';

/*const renderRegister = */ wrapperBuilder.getCustomRenderRegisterInstance();

/*renderRegister.setRenderer(_ => (e, children) => {
  return e(React.Fragment, {}, 'customRender', children);
});*/
